import { writable } from 'svelte/store';

export const appConfigStore = writable();
